import { useEffect, useState } from 'react';

// Breakpoint mobile condiviso (<768px) — coerente con l'@media (max-width:768px)
// già presente in index.css. Usa 767.98px per non collidere sul confine esatto.
// Anti-flicker: lo stato è inizializzato in modo sincrono da matchMedia, così il
// PRIMO render è già corretto (SPA client-side, nessun SSR → nessun mismatch).
const QUERY = '(max-width: 767.98px)';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  );
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
